import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('pickup-store-list', () => import(/* webpackMode: "lazy" */'./pickup-store-list'));
